/** istanbul ignore file */
export const defaultHandler: () => void = () => {};
